<template>
    <div>
        <nav>
            <div class="nav-wrapper">
                <a href="#" class="brand-logo logo">Logo</a>
                <ul id="nav-mobile" class="right hide-on-med-and-down">
                    <li><a href="sass.html">Events</a></li>
                    <li><a href="badges.html">Groups</a></li>
                    <li><a href="collapsible.html">Users</a></li>
                    <li><a href="collapsible.html">Logon</a></li>
                </ul>
            </div>
        </nav>
    </div>
</template>

<script>
    export default {
        name: "Navbar"
    }
</script>

<style scoped>
    .logo{
        margin-left: 20px;
    }
</style>
